module.exports = __webpack_public_path__ + "static/media/square-three.1dd29b03.png";